import { render, staticRenderFns } from "./ParamDropdown.vue?vue&type=template&id=6b16e832&scoped=true&"
import script from "./ParamDropdown.vue?vue&type=script&lang=ts&"
export * from "./ParamDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b16e832",
  null
  
)

export default component.exports